import { useState } from 'react';
import Highlighter from 'react-highlight-words';
import { TSelectProps } from '../interfaces';
import { InputActionMeta } from 'react-select';

const useFormatOptionLabel = (selectProps: TSelectProps, isSelectMenuOpen: boolean) => {
  const {
    dataTest,
    isSupportHighlighting = true,
    handleInputChange,
    formatOptionLabel: customFormatOptionLabel,
    onInputChange: customOnInputChange,
  } = selectProps;

  const [inputSearchValue, setInputSearchValue] = useState<string>('');

  const formatOptionLabel = ({ label }: { label?: string }) => {
    const dataTestAttr = `${ dataTest }_option`;

    return isSupportHighlighting && isSelectMenuOpen
      ? (
        <span data-test={ dataTestAttr } className="Select-menu-list-option">
          <Highlighter
            autoEscape
            searchWords={ [inputSearchValue] }
            textToHighlight={ label?.toString() }
            highlightClassName="matchingText"
          />
        </span>
      )
      : (label);
  };

  const onInputChange = (newValue: string, actionMeta: InputActionMeta) => {
    setInputSearchValue(newValue);

    if (handleInputChange) {
      handleInputChange(newValue, actionMeta);
    }
  };

  return {
    formatOptionLabel: customFormatOptionLabel || formatOptionLabel,
    onInputChange: customOnInputChange || onInputChange,
  };
};

export default useFormatOptionLabel;
